import { render, staticRenderFns } from "./PlayerBar.vue?vue&type=template&id=211fa1f4&scoped=true"
import script from "./PlayerBar.vue?vue&type=script&lang=js"
export * from "./PlayerBar.vue?vue&type=script&lang=js"
import style0 from "./PlayerBar.vue?vue&type=style&index=0&id=211fa1f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211fa1f4",
  null
  
)

export default component.exports